export const FETCH_COUNTRIES_REQUEST = 'FETCH_COUNTRIES_REQUEST';
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_ERROR = 'FETCH_COUNTRIES_ERROR';

export const FETCH_PROVINCES_REQUEST = 'FETCH_PROVINCES_REQUEST';
export const FETCH_PROVINCES_SUCCESS = 'FETCH_PROVINCES_SUCCESS';
export const FETCH_PROVINCES_ERROR = 'FETCH_PROVINCES_ERROR';

export const FETCH_ALL_PROVINCES_REQUEST = 'FETCH_ALL_PROVINCES_REQUEST';
export const FETCH_ALL_PROVINCES_SUCCESS = 'FETCH_ALL_PROVINCES_SUCCESS';
export const FETCH_ALL_PROVINCES_ERROR = 'FETCH_ALL_PROVINCES_ERROR';

export const FETCH_COUNTRY_REQUEST = 'FETCH_COUNTRY_REQUEST';
export const FETCH_COUNTRY_SUCCESS = 'FETCH_COUNTRY_SUCCESS';
export const FETCH_COUNTRY_ERROR = 'FETCH_COUNTRY_ERROR';
